export const LOAD_USER_INFO = "[USER_INFO] LOAD_USER_INFO";
